import React, { useEffect, useState, useRef } from 'react';
// import { useEffectCleanup } from '../Utils/effectCleanup';

const UnderwaterBloodEffect = ({ x, y, onComplete, isActive = true }) => {
  const [droplets, setDroplets] = useState([]);
  const [bubbles, setBubbles] = useState([]);
  const [visible, setVisible] = useState(false); // Start hidden until isActive
  // Removed scheduleCleanup, no longer needed after refactor
  const animationRef = useRef();


  // Only trigger effect when isActive becomes true and x/y are valid
  useEffect(() => {
    if (!isActive || typeof x !== 'number' || typeof y !== 'number' || isNaN(x) || isNaN(y)) {
      setVisible(false);
      window.bloodEffectActive = false;
      return;
    }

    // Generate new droplets and bubbles every time effect is triggered
    const newDroplets = Array(6).fill().map((_, i) => ({
      id: i,
      x: x,
      y: y,
      vx: (Math.random() - 0.5) * 1.5,
      vy: (Math.random() - 0.5) * 1.5,
      size: Math.random() * 3 + 3,
      opacity: 0.85 + Math.random() * 0.15,
      life: 0,
    }));
    const newBubbles = Array(3).fill().map((_, i) => ({
      id: `bubble-${i}-${Date.now()}`,
      x: x + (Math.random() - 0.5) * 40,
      y: y + (Math.random() - 0.5) * 40,
      size: 2 + Math.random() * 4,
    }));

    setVisible(true);
    setDroplets(newDroplets);
    setBubbles(newBubbles);
    window.bloodEffectActive = true;

    const animationDuration = 600;
    const startTime = Date.now();
    let frameCount = 0;

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / animationDuration, 1);
      if (frameCount % 3 === 0) {
        setDroplets(prevDroplets =>
          prevDroplets.map(droplet => {
            const resistance = 1 - progress * 0.4;
            return {
              ...droplet,
              x: droplet.x + droplet.vx * progress * 15 * resistance,
              y: droplet.y + droplet.vy * progress * 15 * resistance,
              life: progress,
              opacity: droplet.opacity * (1 - progress * 0.5),
              size: droplet.size * (1 + progress * 0.4),
            };
          })
        );
      }
      frameCount++;
      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        // Cleanup and call onComplete
        setVisible(false);
        window.bloodEffectActive = false;
        if (typeof onComplete === 'function') onComplete();
      }
    };
    animate();

    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, [isActive, x, y, onComplete]);



  // Don't return null - use CSS visibility to prevent CLS
  // if (!visible) return null;

  return (
    <div
      className="blood-effect-container"
      style={{
        visibility: visible ? 'visible' : 'hidden',
        opacity: visible ? 1 : 0,
        pointerEvents: 'none',
        willChange: 'transform, opacity',
        contain: 'layout style paint',
      }}
    >
      {droplets.map(droplet => (
        (typeof droplet.x === 'number' && typeof droplet.y === 'number' && !isNaN(droplet.x) && !isNaN(droplet.y)) ? (
          <div
            key={droplet.id}
            className="blood-droplet"
            style={{
              left: droplet.x - droplet.size / 2,
              top: droplet.y - droplet.size / 2,
              width: droplet.size,
              height: droplet.size,
              opacity: droplet.opacity,
            }}
          />
        ) : null
      ))}
      {bubbles.map(bubble => (
        (typeof bubble.x === 'number' && typeof bubble.y === 'number' && !isNaN(bubble.x) && !isNaN(bubble.y)) ? (
          <div
            key={bubble.id}
            className="blood-effect-bubble blood-bubble"
            style={{
              left: bubble.x - bubble.size / 2,
              top: bubble.y - bubble.size / 2,
              width: bubble.size,
              height: bubble.size,
            }}
          />
        ) : null
      ))}
    </div>
  );
};

export default UnderwaterBloodEffect;
